import { IDENTITY_CONFIG } from "./authConst";
import { UserManager, WebStorageStateStore} from "oidc-client";
import { config } from '../constants';

export default class AuthService {
    UserManager;

    constructor() {
        this.UserManager = new UserManager({
            ...IDENTITY_CONFIG,
            userStore: new WebStorageStateStore({ store: window.sessionStorage })
        });

        this.UserManager.events.addUserLoaded(async (user) => {
            try {
                localStorage.setItem("id_token", user.id_token);
                const previousOidcToken = localStorage.getItem("oidc_access_token");
                if (previousOidcToken !== user.access_token) {
                    localStorage.setItem("oidc_access_token", user.access_token);
                    console.log("Local JWT updated via /sso-exchange");
                } else {
                    console.log("Same OIDC token, skip /sso-exchange");
                }
            } catch (err) {
                sessionStorage.setItem("ssoLoginError", err.message);
            }
        });

        this.UserManager.events.addSilentRenewError((e) => {
            console.log("silent renew error", e.message);
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            console.log("token expired");
            this.signinSilent();
        });
    }

    signinRedirectCallback = async () => {
    const user = await this.UserManager.signinRedirectCallback();
    localStorage.setItem("id_token", user.id_token);
    return user;
    };

    getUser = async () => {
        const user = await this.UserManager.getUser();
        if (!user) {
            return await this.UserManager.signinRedirectCallback();
        }
        return user;
    };

    parseJwt = (token) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };


    signinRedirect = () => {
        console.log("IDENTITY_CONFIG:", IDENTITY_CONFIG);
        console.log("redirectUri" +  window.location.pathname);
        localStorage.setItem("redirectUri", window.location.pathname);
        this.UserManager.signinRedirect({
        prompt: "login",
        scope: IDENTITY_CONFIG.scope
        });
    };


    navigateToScreen = () => {
        window.location.replace("/signinprofile");
    };


    isAuthenticated = () => {
        const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`))

        return (!!oidcStorage && !!oidcStorage.access_token)
    };

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then((user) => {
                console.log("signed in", user);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token")
        });
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        console.log("signinredirectingcallback");
        console.log('public url is: ' + process.env.REACT_APP_PUBLIC_URL);
        this.UserManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace(process.env.REACT_APP_PUBLIC_URL);
        });
        this.UserManager.clearStaleState();
    };

    exchangeSSOToken = async (token_type, access_token, id_token, expires_in, scope) => {
        try {
            const response = await fetch(config.url.URL + "/api/sso-exchange", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${id_token}`,
                    "Content-Type": "application/json"
                },
                    body: JSON.stringify({
                    token_type: token_type,
                    access_token: access_token,
                    id_token: id_token,
                    expires_in: expires_in,
                    scope: scope
            })
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error("SSO Exchange failed:", errorData);
                throw new Error(errorData.errorCode || "SSO_EXCHANGE_FAILED");
            }

            const { jwt } = await response.json();

            // Stockage du JWT interne DBTV2
            localStorage.setItem("token", jwt);
            localStorage.setItem("authType", "SSO");

            console.log("SSO exchange done, local JWT stored:", jwt);
            return jwt;

        } catch (err) {
            console.error("exchangeSSOToken failed:", err);
            throw err;
        }
    };

/*
    exchangeSSOToken = async (access_token) => {
        try {
            const response = await fetch(config.url.URL + "/api/sso-exchange", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${access_token}`
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errorCode || "SSO_EXCHANGE_FAILED");
            }

            const { jwt } = await response.json();
            localStorage.setItem("token", jwt);
            localStorage.setItem("authType", "SSO");
            console.log("SSO exchange done, new local JWT stored:", jwt);
            return jwt;
        } catch (err) {
            console.error("exchangeSSOToken failed:", err);
             throw err;
        }
    };
*/
    testSigninSilent = () => {
        this.userManager.signinSilent()
            .then(user => {
                console.log("Silent renew OK, nouveau token:", user.access_token);
            })
            .catch(err => {
                console.error("Silent renew FAILED:", err);
            });
    }


}